import { render } from "./Topreferral.vue?vue&type=template&id=df43506e&scoped=true"
import script from "./Topreferral.vue?vue&type=script&lang=js"
export * from "./Topreferral.vue?vue&type=script&lang=js"

import "./Topreferral.vue?vue&type=style&index=0&id=df43506e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df43506e"]])

export default __exports__